/**
 * Persists the last submitted attempt in sessionStorage so a refresh on the results
 * screen does not strand users on the "complimentary attempt used" gate.
 * (sessionStorage clears when the tab closes — appropriate for a transient results view.)
 */
const SESSION_PREFIX = 'certpro_session_v1_'

export function saveCertificationSession(trackId, payload) {
  try {
    window.sessionStorage.setItem(`${SESSION_PREFIX}${trackId}`, JSON.stringify({ version: 1, ...payload }))
  } catch {
    // ignore
  }
}

export function loadCertificationSession(trackId) {
  try {
    const raw = window.sessionStorage.getItem(`${SESSION_PREFIX}${trackId}`)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (data?.version !== 1 || !data?.result) return null
    return data
  } catch {
    return null
  }
}

export function clearCertificationSession(trackId) {
  try {
    window.sessionStorage.removeItem(`${SESSION_PREFIX}${trackId}`)
  } catch {
    // ignore
  }
}
